import {
    OnInit,
    Input,
    Component
} from '@angular/core';

@Component({
    selector: '[tree-template]',
    templateUrl: './checkbox-tree-template.component.html',
    styleUrls: ['./checkbox-tree-template.component.scss']
})
export class CheckboxTreeTemplateComponent implements OnInit {
    @Input('tree-template') item: any;
    @Input() public rowDirective: any;
    @Input() public rowDirectiveLevels: any;
    @Input() public expandItem: Function;
    @Input() public collapseItem: Function;
    @Input() public selectItem: Function;
    @Input() public toggleChildren: Function;

    constructor() { }

    ngOnInit(): void { }
}
